import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import LoginPage from './Pages/LoginPage/LoginPage';
import SignUpPage from './Pages/SignUpPage/SignUpPage';
import OtpPage from './Pages/OtpPage/OtpPage';
import NavBar from './Components/NavBar/NavBar';
import BranchesPage from './Pages/BranchesPage/BranchesPage';
import CategoriesPage from './Pages/CategoriesPage/CategoriesPage';
import HomePage from './Pages/HomePage/HomePage';
import ServiesPage from './Pages/ServiesPage/ServiesPage';
import Details from './Components/Servies/Details';
import ServiceProvidersPage from './Pages/ServiceProvidersPage/ServiceProvidersPage';
import TimePage from './Pages/TimePage/TimePage';
import PackagesPage from './Pages/PackagesPage/PackagesPage';
import PackageDetails from './Components/Packages/PackageDetails';
import UserBookingsPage from './Pages/Bookings/UserBookingsPage';
import CartPage from './Pages/CartPage/CartPage';
import CheckOutPage from './Pages/CheckOutPage/CheckOutPage';
import ProfilePage from './Pages/ProfilePage/ProfilePage';
import ContactPage from './Pages/ContactPage/ContactPage';
import TermsPage from './Pages/TermsPage/TermsPage';
import CheckOutPackagePage from './Pages/CheckOutPackagePage/CheckOutPackagePage';
import ProtectedRoute from './ProtectedRoute';
import './App.css'
import ServiceProvidersForPackagePage from './Pages/ServiceProvidersForPackagePage/ServiceProvidersForPackagePage';
import TimeForPackagePage from './Pages/TimeForPackagePage/TimeForPackagePage';
import RatePage from './Pages/RatePage/RatePage';
import Footer from './Components/Footer/Footer';

function RoutesWrapper() {
  const location = useLocation(); // Ensured it's within BrowserRouter

  const hideNavBar = ['/login', '/signup', '/otp', '/branches','/rate'].includes(location.pathname);
  const hideFooter = ['/rate'].includes(location.pathname);
const user = JSON.parse(localStorage.getItem('user')) 



  return (
    <>
      {!hideNavBar && <NavBar />}
      <Routes>
      <Route path="/" element={user ? <Navigate to="/HomePage" /> : <Navigate to="/login" />} />        <Route index path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />
          <Route path="/otp" element={<OtpPage />} />
          <Route path='/rate' element={<RatePage />} />


        <Route element={<ProtectedRoute />}>
        <Route path="*" element={<Navigate to="/HomePage" replace />} />
          <Route path="/branches" element={<BranchesPage />} />
          <Route path="/categories/:branchId?" element={<CategoriesPage />} />
          <Route path="/services" element={<ServiesPage />} />
          <Route path="/details" element={<Details />} />
          <Route path="/serviceproviders" element={<ServiceProvidersPage />} />
          <Route path="/ServiceProvidersForPackageServices" element={<ServiceProvidersForPackagePage />} />
          <Route path="/time" element={<TimePage />} />
          <Route path="/TimeForPackage" element={<TimeForPackagePage />} />
          <Route path="/HomePage" element={<HomePage />} />
          <Route path="/Packages" element={<PackagesPage />} />
          <Route path="/PackageDetails" element={<PackageDetails />} />
          <Route path='/bookings' element={<UserBookingsPage />} />
          <Route path='/cart' element={<CartPage />} />
          <Route path='/checkout' element={<CheckOutPage />} />
          <Route path='/checkoutPackage' element={<CheckOutPackagePage />} />
          <Route path='/profile' element={<ProfilePage />} />
          <Route path='/contact' element={<ContactPage />} />
          <Route path='/terms' element={<TermsPage />} />
        </Route>

      </Routes>
     {!hideFooter && <Footer />}

    </>
  );
}

export default RoutesWrapper;
